export default {
  name: 'StandardPage',
  components: {},

  setup() {
    return {};
  }

};